import React, { useState, useRef } from "react";
import { getAllCountries } from "../data/countries";
import { getUsStates } from "../data/us_states";

const ScheduleDemoForm = () => {
  let countries = getAllCountries();
  let usStates = getUsStates();
  const form = useRef();
  const submitSuccess = useRef();
  const submitFailed = useRef();
  const [displayState, setDisplayState] = useState(false);
  const [isFormValid, setFormValid] = useState(false);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [errMsg, setErrMsg] = useState("");

  const [mailerState, setMailerState] = useState({
    form: "schedule_demo_form",
    firstName: "",
    lastName: "",
    schoolDistrict: "",
    country: "",
    streetAddress: "",
    city: "",
    state: "",
    workEmail: "",
    phone: "",
    existingClient: "",
    initialDemoParticipant: "",
    demoRequestDetails: "",
  });

  const [formErrors, setFormErrors] = useState({
    form: "schedule_demo_form",
    firstName: "",
    lastName: "",
    schoolDistrict: "",
    country: "",
    streetAddress: "",
    city: "",
    state: "",
    workEmail: "",
    phone: "",
    existingClient: "",
    initialDemoParticipant: "",
    demoRequestDetails: "",
  });

  // function handleStateChange(e) {
  //   const { name, value } = e.target;
  //   setMailerState({ ...mailerState, [name]: value });

  //   if (name == "country" && value == "United States of America") {
  //     setDisplayState(true);
  //   } else if (name == "country" && value != "United States of America") {
  //     setDisplayState(false);
  //   }
  // } // end of handleStateChange

  // const submitEmail = async (e) => {
  //   e.preventDefault();
  //   setIsFormSubmitted(isFormSubmitted);
  //   const api_url = process.env.REACT_APP_SEND_EMAIL;

  //   //validate form before sending
  //   let errors = {};
  //   // check values and remove white space before and after the value
  //   mailerState.firstName = mailerState.firstName.trim();
  //   mailerState.lastName = mailerState.lastName.trim();
  //   mailerState.schoolDistrict = mailerState.schoolDistrict.trim();
  //   mailerState.streetAddress = mailerState.streetAddress.trim();
  //   mailerState.city = mailerState.city.trim();
  //   mailerState.workEmail = mailerState.workEmail.trim();
  //   mailerState.phone = mailerState.phone.trim();

  //   if (!mailerState.firstName) {
  //     errors.firstName = "First Name is required";
  //     setFormValid(false);
  //   } else setFormValid(true);
  //   if (!mailerState.lastName) {
  //     errors.lastName = "Last Name is required";
  //     setFormValid(false);
  //   } else setFormValid(true);
  //   if (!mailerState.schoolDistrict) {
  //     errors.schoolDistrict = "School District is required";
  //     setFormValid(false);
  //   } else setFormValid(true);
  //   if (!mailerState.streetAddress) {
  //     errors.streetAddress = "Street Address is required";
  //     setFormValid(false);
  //   } else setFormValid(true);
  //   if (!mailerState.city) {
  //     errors.city = "City is required";
  //     setFormValid(false);
  //   } else setFormValid(true);
  //   if (!mailerState.country) {
  //     errors.country = "Country is required";
  //     setFormValid(false);
  //   } else setFormValid(true);
  //   if (!mailerState.workEmail) {
  //     errors.workEmail = "Email is required";
  //     setFormValid(false);
  //   } else setFormValid(true);
  //   if (!mailerState.phone) {
  //     errors.phone = "Phone is required";
  //     setFormValid(false);
  //   } else if (mailerState.phone.length < 10) {
  //     errors.phone = "Phone number must be 10 digits";
  //     setFormValid(false);
  //   } else setFormValid(true);
  //   if (
  //     mailerState.country == "United States of America" &&
  //     !mailerState.state
  //   ) {
  //     errors.state = "State is required";
  //     setFormValid(false);
  //   } else if (
  //     mailerState.country == "United States of America" &&
  //     mailerState.state
  //   ) {
  //     errors.state = "";
  //     setFormValid(true);
  //   }
  //   if (!mailerState.existingClient) {
  //     errors.existingClient = "Please select an option";
  //     setFormValid(false);
  //   } else setFormValid(true);
  //   if (!mailerState.initialDemoParticipant) {
  //     errors.initialDemoParticipant = "Please select an option";
  //     setFormValid(false);
  //   } else setFormValid(true);
  //   if (!mailerState.demoRequestDetails) {
  //     errors.demoRequestDetails = "Please input details and availability";
  //     setFormValid(false);
  //   } else setFormValid(true);
  //   setFormErrors(errors);

  //   if (isFormValid) {
  //     // eslint-disable-next-line
  //     const response = await fetch(api_url, {
  //       method: "POST",
  //       headers: {
  //         "Content-type": "application/json",
  //       },
  //       body: JSON.stringify({ mailerState }),
  //     })
  //       .then((res) => res.json())
  //       .then(
  //         (res) => {
  //           setMailerState({
  //             form: "schedule_demo_form",
  //             firstName: "",
  //             lastName: "",
  //             schoolDistrict: "",
  //             country: "",
  //             streetAddress: "",
  //             city: "",
  //             state: "",
  //             workEmail: "",
  //             phone: "",
  //             existingClient: "",
  //             initialDemoParticipant: "",
  //             demoRequestDetails: "",
  //           });
  //           setIsFormSubmitted(!isFormSubmitted);
  //           submitSuccess.current.value =
  //             "Thank you! We will be in touch soon.";
  //           setTimeout(function () {
  //             window.location.reload(1);
  //           }, 5000);
  //         },
  //         (error) => {
  //           setIsFormSubmitted(!isFormSubmitted);
  //           submitFailed.current.value = "Send Failed. Please try again later.";
  //           setTimeout(function () {
  //             window.location.reload(1);
  //           }, 5000);
  //         }
  //       );
  //     e.target.reset();
  //   }
  // }; // end of submitEmail

  function handleStateChange(e) {
    const { name, value } = e.target;
    setMailerState({ ...mailerState, [name]: value });
  
    if (name === "country" && value === "United States of America") {
      setDisplayState(true);
    } else if (name === "country" && value !== "United States of America") {
      setDisplayState(false);
    }
  } // end of handleStateChange
  
  const submitEmail = async (e) => {
    e.preventDefault();
    setIsFormSubmitted(isFormSubmitted);
    const api_url = process.env.REACT_APP_SEND_EMAIL;
  
    //validate form before sending
    let errors = {};
    // check values and remove white space before and after the value
    mailerState.firstName = mailerState.firstName.trim();
    mailerState.lastName = mailerState.lastName.trim();
    mailerState.schoolDistrict = mailerState.schoolDistrict.trim();
    mailerState.streetAddress = mailerState.streetAddress.trim();
    mailerState.city = mailerState.city.trim();
    mailerState.workEmail = mailerState.workEmail.trim();
    mailerState.phone = mailerState.phone.trim();
  
    if (!mailerState.firstName) {
      errors.firstName = "First Name is required";
      setFormValid(false);
    } else setFormValid(true);
    if (!mailerState.lastName) {
      errors.lastName = "Last Name is required";
      setFormValid(false);
    } else setFormValid(true);
    if (!mailerState.schoolDistrict) {
      errors.schoolDistrict = "School District is required";
      setFormValid(false);
    } else setFormValid(true);
    if (!mailerState.streetAddress) {
      errors.streetAddress = "Street Address is required";
      setFormValid(false);
    } else setFormValid(true);
    if (!mailerState.city) {
      errors.city = "City is required";
      setFormValid(false);
    } else setFormValid(true);
    if (!mailerState.country) {
      errors.country = "Country is required";
      setFormValid(false);
    } else setFormValid(true);
    if (!mailerState.workEmail) {
      errors.workEmail = "Email is required";
      setFormValid(false);
    } else setFormValid(true);
    if (!mailerState.phone) {
      errors.phone = "Phone is required";
      setFormValid(false);
    } else if (mailerState.phone.length < 10) {
      errors.phone = "Phone number must be 10 digits";
      setFormValid(false);
    } else setFormValid(true);
    if (
      mailerState.country === "United States of America" &&
      !mailerState.state
    ) {
      errors.state = "State is required";
      setFormValid(false);
    } else if (
      mailerState.country === "United States of America" &&
      mailerState.state
    ) {
      errors.state = "";
      setFormValid(true);
    }
    if (!mailerState.existingClient) {
      errors.existingClient = "Please select an option";
      setFormValid(false);
    } else setFormValid(true);
    if (!mailerState.initialDemoParticipant) {
      errors.initialDemoParticipant = "Please select an option";
      setFormValid(false);
    } else setFormValid(true);
    if (!mailerState.demoRequestDetails) {
      errors.demoRequestDetails = "Please input details and availability";
      setFormValid(false);
    } else setFormValid(true);
    setFormErrors(errors);
  
    if (isFormValid) {
      // eslint-disable-next-line
      const response = await fetch(api_url, {
        method: "POST",
        headers: {
          "Content-type": "application/json",
        },
        body: JSON.stringify({ mailerState }),
      })
        .then((res) => res.json())
        .then(
          (res) => {
            setMailerState({
              form: "schedule_demo_form",
              firstName: "",
              lastName: "",
              schoolDistrict: "",
              country: "",
              streetAddress: "",
              city: "",
              state: "",
              workEmail: "",
              phone: "",
              existingClient: "",
              initialDemoParticipant: "",
              demoRequestDetails: "",
            });
            setIsFormSubmitted(!isFormSubmitted);
            submitSuccess.current.value =
              "Thank you! We will be in touch soon.";
            setTimeout(function () {
              window.location.reload(1);
            }, 5000);
          },
          (error) => {
            setIsFormSubmitted(!isFormSubmitted);
            submitFailed.current.value =
              "Send Failed. Please try again later.";
            setTimeout(function () {
              window.location.reload(1);
            }, 5000);
          }
        );
      e.target.reset();
    }
  }; // end of submitEmail
  

  return (
    <>
      {isFormSubmitted ? (
        <div className="demo-submit-msg">
          <input
            style={{
              width: "100%",
              textAlign: "center",
              border: "none",
              fontSize: "1.4em",
              backgroundColor: "transparent",
            }}
            id="successMsg"
            ref={submitSuccess}
            value={successMsg}
            onChange={(e) => setSuccessMsg(e.target.value)}
            disabled
          ></input>
          <input
            style={{
              width: "100%",
              textAlign: "center",
              border: "none",
              fontSize: "1.4em",
              backgroundColor: "transparent",
            }}
            id="successMsg"
            ref={submitFailed}
            value={errMsg}
            onChange={(e) => setErrMsg(e.target.value)}
            disabled
          ></input>
        </div>
      ) : (
        <form id="schedule_demo_form" ref={form} onSubmit={submitEmail}>
          <h3>Schedule A Demo</h3>
          <div>
            <div className="form-group">
              <div>
                <label htmlFor="firstName">
                  First Name<span className="required">*</span>
                </label>
                <input
                  type="text"
                  id="firstName"
                  name="firstName"
                  onChange={handleStateChange}
                  autoComplete="off"
                  value={mailerState.firstName}
                />
                {formErrors.firstName && (
                  <span className="errorMessage">{formErrors.firstName}</span>
                )}
              </div>
              <div>
                <label htmlFor="lastName">
                  Last Name<span className="required">*</span>
                </label>
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  onChange={handleStateChange}
                  autoComplete="off"
                  value={mailerState.lastName}
                />
                {formErrors.lastName && (
                  <span className="errorMessage">{formErrors.lastName}</span>
                )}
              </div>
              <div>
                <label htmlFor="schoolDistrict">
                  School District<span className="required">*</span>
                </label>
                <input
                  type="text"
                  id="schoolDistrict"
                  name="schoolDistrict"
                  onChange={handleStateChange}
                  autoComplete="off"
                  value={mailerState.schoolDistrict}
                />
                {formErrors.schoolDistrict && (
                  <span className="errorMessage">
                    {formErrors.schoolDistrict}
                  </span>
                )}
              </div>
              <div>
                <label htmlFor="country">
                  Country<span className="required">*</span>
                </label>
                <select
                  id="country"
                  name="country"
                  onChange={handleStateChange}
                  autoComplete="off"
                  value={mailerState.country}
                >
                  <option value="">Select Country</option>
                  {countries.map((country) => (
                    <option key={country.id} value={country.name}>
                      {country.name}
                    </option>
                  ))}
                </select>
                {formErrors.country && (
                  <span className="errorMessage">{formErrors.country}</span>
                )}
              </div>
              <div>
                <label htmlFor="streetAddress">
                  Street Address<span className="required">*</span>
                </label>
                <input
                  type="text"
                  id="streetAddress"
                  name="streetAddress"
                  onChange={handleStateChange}
                  autoComplete="off"
                  value={mailerState.streetAddress}
                />
                {formErrors.streetAddress && (
                  <span className="errorMessage">
                    {formErrors.streetAddress}
                  </span>
                )}
              </div>
              <div>
                <label htmlFor="city">
                  City<span className="required">*</span>
                </label>
                <input
                  type="text"
                  id="city"
                  name="city"
                  onChange={handleStateChange}
                  autoComplete="off"
                  value={mailerState.city}
                />
                {formErrors.city && (
                  <span className="errorMessage">{formErrors.city}</span>
                )}
              </div>
              <div className={displayState ? "show" : "hide"}>
                <label htmlFor="state">
                  State<span className="required">*</span>
                </label>
                <select
                  id="state"
                  name="state"
                  onChange={handleStateChange}
                  autoComplete="off"
                  value={mailerState.state}
                >
                  <option value="">Select State</option>
                  {usStates.map((usState) => (
                    <option key={usState.id} value={usState.name}>
                      {usState.name}
                    </option>
                  ))}
                </select>
                {formErrors.state && (
                  <span className="errorMessage">{formErrors.state}</span>
                )}
              </div>
              <div>
                <label htmlFor="workEmail">
                  Work Email<span className="required">*</span>
                </label>
                <input
                  type="email"
                  id="workEmail"
                  name="workEmail"
                  onChange={handleStateChange}
                  autoComplete="off"
                  value={mailerState.workEmail}
                />
                {formErrors.workEmail && (
                  <span className="errorMessage">{formErrors.workEmail}</span>
                )}
              </div>
              <div>
                <label htmlFor="phone">
                  Phone<span className="required">*</span>
                </label>
                <input
                  type="number"
                  id="phone"
                  name="phone"
                  onChange={handleStateChange}
                  autoComplete="off"
                  value={mailerState.phone}
                />
                {formErrors.phone && (
                  <span className="errorMessage">{formErrors.phone}</span>
                )}
              </div>
              <div>
                <label htmlFor="existingClient">
                  Are you an existing META Customizations Client?
                  <span className="required">*</span>
                </label>
                <select
                  id="existingClient"
                  name="existingClient"
                  onChange={handleStateChange}
                  autoComplete="off"
                  value={mailerState.existingClient}
                >
                  <option value="">Select</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
                {formErrors.existingClient && (
                  <span className="errorMessage">
                    {formErrors.existingClient}
                  </span>
                )}
              </div>
              <div>
                <label htmlFor="initialDemoParticipant">
                  Have you already participated in an initial demo?
                  <span className="required">*</span>
                </label>
                <select
                  id="initialDemoParticipant"
                  name="initialDemoParticipant"
                  onChange={handleStateChange}
                  autoComplete="off"
                  value={mailerState.initialDemoParticipant}
                >
                  <option value="">Select</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
                {formErrors.initialDemoParticipant && (
                  <span className="errorMessage">
                    {formErrors.initialDemoParticipant}
                  </span>
                )}
              </div>
              <div>
                <label htmlFor="demoRequestDetails">
                  Details regarding demo and possible date availability
                  <span className="required">*</span>
                </label>
                <textarea
                  id="demoRequestDetails"
                  name="demoRequestDetails"
                  placeholder="Input details regarding you demo request including all possible date availability here..."
                  onChange={handleStateChange}
                  autoComplete="off"
                  value={mailerState.demoRequestDetails}
                  rows="4"
                />
                {formErrors.demoRequestDetails && (
                  <span className="errorMessage">
                    {formErrors.demoRequestDetails}
                  </span>
                )}
              </div>
            </div>
            <div id="demo-btn">
              <button type="submit">Submit</button>
            </div>
          </div>
        </form>
      )}
    </>
  );
};

export default ScheduleDemoForm;
